import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import defaultLogo from '../../images/logo.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile'
import './Navbar.css'
import { guardarSiteConfig, obtenerLogoGuardado, obtenerNombreTiendaGuardado } from '../siteConfig';
import ButonInstallAppNav from '../Admin/ButonInstallAppNav/ButonInstallAppNav';

import Favoritos from '../Favoritos/Favoritos'
import InputSerach from '../InputSerach/InputSearchs'
export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);
    const [storeName, setStoreName] = useState(() => obtenerNombreTiendaGuardado());

    useEffect(() => {
        cargarBanners();
        cargarLogo();
    }, []);

    const cargarLogo = async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php`);
            const data = await response.json();
            if (data.config) {
                guardarSiteConfig(data.config);
            }
            if (data.config?.logo) {
                setAppLogo(data.config.logo);
            }
            setStoreName(data.config?.nombreTienda?.trim() || '');
        } catch (error) {
            console.error('Error al cargar el logo:', error);
        }
    };

    const palabrasNombre = storeName.trim().split(/\s+/).filter(Boolean);
    const encabezadoSuperior = palabrasNombre[0] || '';
    const encabezadoInferior = palabrasNombre.slice(1).join(' ');

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = Array.isArray(data.banner) ? data.banner.map(banner => banner.imagen) : [];
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)

            });
    };

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    <img src={appLogo} alt="logo" />
                    {storeName && (
                        <span className='logoTitleStack'>
                            <span>{encabezadoSuperior}</span>
                            {encabezadoInferior && <span>{encabezadoInferior}</span>}
                        </span>
                    )}
                </Anchor>

                <div className='deFLexNavs'>
                    <ButonInstallAppNav label='Descargar App' className='btnInstallHeader' />
                    <Favoritos />

                    <InputSerach />
                    <div className={`nav_toggle  ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>


                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'>

                            </div>

                        ) : (

                            <>
                                <div className='fondo'>
                                    <img src={images[0]} alt={`imagen`} />

                                </div>
                                <Profile />

                            </>
                        )}

                    </div>
                </Modal>

            </nav>
        </header>
    );
}
